export default __webpack_public_path__ + "static/media/Maxdol-60-mg-IM-IV-eng.79bb37d1.jpg";